"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableHead_1 = require("./TableHead");
exports.default = TableHead_1.default;
//# sourceMappingURL=index.js.map